import { render, staticRenderFns } from "./SpoiledItemIcon.vue?vue&type=template&id=35089f2f&scoped=true&"
import script from "./SpoiledItemIcon.vue?vue&type=script&lang=js&"
export * from "./SpoiledItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35089f2f",
  null
  
)

export default component.exports